
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 42"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(1 1)"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","stroke":"#E73273","stroke-width":"2"}}),_c('path',{attrs:{"fill":"#E73273","fill-rule":"nonzero","d":"M21.478 18.522h8.358v2.956h-8.358v8.358h-2.956v-8.358h-8.358v-2.956h8.358v-8.358h2.956v8.358z"}})])])
          )
        }
      }
    